import { useAuth0 } from "@auth0/auth0-react";
import { useAuthStore } from "@state/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import PopoverMenu from "@components/editor/PopoverMenu";
import MenuItem from "@mui/material/MenuItem";
import LogoutIcon from "@mui/icons-material/Logout";
import { Tooltip } from "@mui/material";

interface NavBarProps {
  goBack?: boolean;
  showUser?: boolean;
}

const NavBar = ({ goBack, showUser = true }: NavBarProps) => {
  const user = useAuthStore((state) => state.user);
  const { logout } = useAuth0();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <nav className="flex flex-row items-center justify-between">
      {goBack ? (
        <button onClick={handleBack}>
          <Tooltip
            title="Back"
            placement="top"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 19.5 8.25 12l7.5-7.5"
              />
            </svg>
          </Tooltip>
        </button>
      ) : (
        <h1 className="text-xl font-bold">{user.name}&apos;s Workspace</h1>
      )}

      {showUser && (
        <>
          <button onClick={handleClick}>
            <img
              src={user.profilePicture}
              alt={user.name}
              className="w-10 h-10 rounded-full"
            />
          </button>

          <PopoverMenu
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem
              disableRipple
              onClick={() =>
                logout({
                  logoutParams: {
                    returnTo: window.location.origin,
                  },
                })
              }
            >
              <LogoutIcon />
              Logout
            </MenuItem>
          </PopoverMenu>
        </>
      )}
    </nav>
  );
};

export default NavBar;
